<template>
    <footer>
        <section class="footer-info d-flex flex-row justify-content-center py-2">
            <p>{{$t('com.file.footer-component.need-help-info-phone')}} <b>{{$t('com.file.footer-component.helpdesk-phone-number')}}</b> {{$t('com.file.footer-component.need-help-info-or-email')}} <b>{{$t('com.file.footer-component.helpdesk-email')}}</b> {{$t('com.file.footer-component.need-help-info-with-id')}} <b>{{this.$store.state.userStore.userData.client_id}}</b> </p>
        </section>
    </footer>
</template>

<script>
    export default {
        name: "FooterComponent",
        components: {

        },
        data() {
            return {
            };
        },
        computed: {

        },
        methods: {
            
        }
    };
</script>

<style lang="scss" scoped>
    .footer-info {
        background: white;
        font-size: 12px;
        text-align: center;
    }
</style>
